import { useQuery } from '@findify/react-connect'
import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import { useMedia } from '../../hooks'
import classes from './SearchInput.module.scss'

const SearchInput = ({ closeSearch }) => {
    const { update } = useQuery()
    const [query, setQuery] = useState('')

    useEffect(() => {
        update('q', query)
    }, [query, update])

    const isMobile = useMedia('(max-width: 991.8px)');

    return (
        <div className={classes.root}>
            <input onChange={(e) => setQuery(e.target.value)} autoFocus className={clsx('form-control', classes.input)} placeholder="Search" />
            {
                isMobile && <button title="close search" onClick={closeSearch} className="btn"><i className="fa fa-close" /></button>
            }
        </div>
    )
}

export default SearchInput